import { history } from "../../../_components/_helpers/history"
import { 
    store,
    dataProvider,
    config
} from "../../../studentportal-sdk"



export const Authentication = (props) => {

    // data provider modules
    const {
        asapceoApi
    } = dataProvider

    // store module
    const { 
        useConnection,
        utilityAndConfigStore,
    } = store.zustand

    // connection store
    const { 
        authToken,
        emailVerified,
        signedUp,
        authenticated,
        _hasHydrated,
        authUser, 
        setAuthUser,
        setAuthToken,
        setEmailVerified,
        toggleSignedUp,
        disConnectAuthUser,
        role,
        setRole,
        users,
        getUsers,
    } = useConnection((state) => ({
        users:state.users,
        getUsers:state.getUsers, 
        emailVerified: state.emailVerified,
        signedUp: state.signedUp,
        _hasHydrated: state._hasHydrated,
        authenticated: state.authenticated,
        authUser: state.authUser, 
        setAuthUser: state.setAuthUser,
        setAuthToken: state.setAuthToken,
        setEmailVerified: state.setEmailVerified,
        toggleSignedUp: state.toggleSignedUp,
        disConnectAuthUser: state.disConnectAuthUser,
        role:state.role,
        setRole: state.setRole
    }))

    // app utility and configuration store
    const { 
        setMessage,
        startLoading,
        stopALoadingProccess,
        loading
    } = utilityAndConfigStore((state) => ({ 
        loading:state.loading,
        setMessage: state.setMessage,
        startLoading: state.startLoading,
        stopALoadingProccess: state.stopALoadingProccess,
    }))

     /**
     * 
     * @param param0 
     * 
     * sign up account
     */
    const getAllUsers = () => {
    (async () => {
        const users = await asapceoApi.getAllUsers()

        users.status && getUsers(users.data)
    })()
    }
    
    /**
     * 
     * @param param0 
     * 
     * sign up account
     */
     const userAccountSignUp = ({ 
        email,
        firstname,
        lastname,
        password,
        confirmPassword,
        category,
        group,
        phone,
        isBaptised
    }) => {
        (async () => {
            // start loading a process
            startLoading({
                internalLoading: true,
            })
            //asapceo api request signUp
            const user = await asapceoApi.userAccountSignUp({
                email,
                firstname,
                lastname,
                password,
                confirmPassword,
                category,
                group,
                phone,
                isBaptised
            })

            // report occured error
            user?.error 
            && setMessage({
                type: 'error',
                show: true,
                title: config.constants.authMessage.titleError,
                // description: user?.message,
                description: user?.message,
                alert: true,
                inLine: true
            });

            // report success
            user?.status
            && setMessage({
                type: 'success',
                show: true,
                title: config.constants.authMessage.titleSuccess,
                // description: user?.message,
                description: config.constants.happyReport,
                alert: true,
                inLine: true
            });

            // stop loading process
            user && stopALoadingProccess();

            // detect sign up
            user?.status && toggleSignedUp();
        })()
    }

    /**
     * 
     * @param param0 
     * 
     * sign in account
     */
    const userAccountSignIn = ({ email, password }) => {
        (async () => {
            // start loading a process
            startLoading({
                internalLoading: true,
            })

            //asapceo api request signIn
            const user = await asapceoApi.userAccountSignIn({
                email: email,
                password: password,
                authProvider: "email",
            })
            // update user document
            user?.data 
            && setAuthUser(user?.data || {})
            // update user auth token doc
            user?.data?.token 
            && setAuthToken(user?.data?.token || '')
            // store token to local storage (this is temporary fix, will refactor later)
            user?.data?.token 
            && localStorage.setItem('authToken', user?.data?.token)

            user?.data?.id 
            && localStorage.setItem('userId', user?.data?.id)

            user?.data?.role 
            && setRole(user?.data?.role || '')

            user?.data?.role 
            && localStorage.setItem('role', user?.data?.role)

              // report success
              user?.status
              && setMessage({
                  type: 'success',
                  show: true,
                  title: config.constants.authMessage.titleSuccess,
                  // description: user?.message,
                  description: config.constants.happyReport,
                  alert: true,
                  inLine: true
              });
            // report occured error
            user?.error 
            && setMessage({
                type: 'error',
                show: true,
                title: config.constants.authMessage.titleError,
                description: user?.message,
                alert: true,
                inLine: true
            });
            user && stopALoadingProccess();
        })()
    }

     /**
     * Logout
     */

     const userLogout = async () => {
        setAuthUser(null);
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("role");
        window.location.href = "/login"; // Redirect to login page
      };

    /**
     * account verify email
     */

    const userEmailVerification = ({
        email
    }) => {
        (async () => {
            // start loading a process
            startLoading({
                internalLoading: true,
            })
            //asapceo api request verify email
            const user = await asapceoApi.userAccountEmailVerfication({
                email
            })
            // validate verification status
            user?.status 
            && setEmailVerified(true)

             // report success
             user?.status
             && setMessage({
                 type: 'success',
                 show: true,
                 title: config.constants.authMessage.titleSuccess,
                 description: user?.message,
                //  description: config.constants.happyReport,
                 alert: true,
                 inLine: true
             });
            // report occured error
            user?.error 
            && setMessage({
                type: 'error',
                show: true,
                title: config.constants.authMessage.titleError,
                // description: user?.message,
                description: user?.message,
                alert: true,
                inLine: true
            })
            user?.error && setEmailVerified(false)
            user && stopALoadingProccess();
        })()
    }


    const verifyToken = (formdata) => {
        (async () => {
            // start loading a process
            startLoading({
                internalLoading: true,
            })
            //asapceo api request verify email
            const user = await asapceoApi.verifyToken(formdata)
            // validate verification status
            user?.status 
            && (window.location.href = `/resetpassword?token=${formdata.token}`)
            // report occured error
            user?.error 
            && setMessage({
                type: 'error',
                show: true,
                title: config.constants.authMessage.titleError,
                // description: user?.message,
                description: user?.message,
                alert: true,
                inLine: true
            })
            user?.error && setEmailVerified(false)
            user && stopALoadingProccess();
        })()
    }

    const resetPassword = (formdata) => {
        (async () => {
            // start loading a process
            startLoading({
                internalLoading: true,
            })
            //asapceo api request verify email
            const user = await asapceoApi.resetPassword(formdata)
            // validate verification status
            // user?.status 
            // && setEmailVerified(true)
            // report occured error
            user?.error 
            && setMessage({
                type: 'error',
                show: true,
                title: config.constants.authMessage.titleError,
                // description: user?.message,
                description: user?.message,
                alert: true,
                inLine: true
            })
            user?.error && setEmailVerified(false)
            user && stopALoadingProccess();
        })()
    }

    /**
     * sign out account
     */
    const userAccountSignOut = () => {
        disConnectAuthUser()
    }

    return {
        store: {
            emailVerified,
            signedUp,
            authToken,
            authenticated,
            _hasHydrated,
            authUser, 
            role, 
            users,
            loading
        },

        action: {
            getAllUsers,
            userEmailVerification,
            userAccountSignUp,
            userAccountSignIn,
            userAccountSignOut,
            userLogout,
            verifyToken,
            resetPassword
        },
        history,
        ...props
    }
}